"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const webview_app_1 = require("@/webview_app");
const svgs_1 = require("@@/assets/svgs");
const components_1 = require("@/common/components");
const functions_1 = require("@/common/functions");
const eggs_1 = require("@/common/eggs");
const material_ui_confirm_1 = require("material-ui-confirm");
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Menu_1 = __importDefault(require("@mui/material/Menu"));
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
function default_1() {
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const open = Boolean(anchorEl);
    const openMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const closeMenu = () => {
        setAnchorEl(null);
    };
    const roomId = (0, react_redux_1.useSelector)((state) => state.roomData.id);
    const isLoggedIn = (0, react_redux_1.useSelector)((state) => state.whoAmI.is_logged_in);
    const handleQnaClick = () => {
        const qnaPath = '/fondee/qna/';
        if (isLoggedIn)
            window.location.href = qnaPath;
        else
            window.location.href = `/login/?next_page=${qnaPath}`;
    };
    const handleReportClick = () => {
        const reportPath = `/fondee/report/?roomId=${roomId}`;
        if (isLoggedIn)
            window.location.href = reportPath;
        else
            window.location.href = `/login/?next_page=${reportPath}`;
    };
    const channelId = (0, react_redux_1.useSelector)((state) => state.roomData.leader);
    const userId = (0, react_redux_1.useSelector)((state) => state.whoAmI.id);
    const leaderNick = (0, react_redux_1.useSelector)((state) => state.roomData.leader_nick);
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const [pending, setPending] = (0, react_1.useState)(false);
    const blockLeader = () => {
        (0, functions_1.tempDisableClick)(3000);
        (0, functions_1.delay)(10).then(() => {
            (0, functions_1.changeBlockState)({
                isLoggedIn,
                setPending,
                channelId,
                onBlockChanged: () => setTimeout(functions_1.goToMain, 2000),
                channelName: leaderNick,
            });
        });
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    const isSubscribe = (0, react_redux_1.useSelector)((state) => state.roomData.is_subscribe);
    const handleBlockLeaderClick = () => {
        if (isLoggedIn) {
            if (channelId === userId) {
                (0, eggs_1.preventMyself)({ confirm, message: t('자신을 차단하진 말아요') });
            }
            else {
                confirm({
                    contentProps: {
                        sx: Object.assign(Object.assign({}, components_1.muiConfirmContentPropsSx), { '+ div': {
                                flexDirection: 'row-reverse',
                            } }),
                    },
                    description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('channelName님을 차단하면', { channelName: leaderNick }), (0, jsx_runtime_1.jsx)("br", {}), t('앞으로 서로의 폼을 볼 수 없어요.'), (0, jsx_runtime_1.jsx)("br", {}), t('차단하시겠어요?')] })),
                    confirmationText: t('차단할게요'),
                })
                    .then(() => {
                    if (!pending) {
                        setPending(true);
                        if (isSubscribe) {
                            (0, functions_1.changeSubscribeState)({
                                channelId,
                                onSubsChanged: blockLeader,
                            });
                        }
                        else {
                            blockLeader();
                        }
                    }
                })
                    .catch(() => { });
            }
        }
        else {
            (0, functions_1.showToastMessage)({ message: t('차단은 로그인 후 이용할 수 있어요!') });
        }
    };
    const isDemandSurvey = (0, react_redux_1.useSelector)((state) => state.isDemandSurvey);
    const isCommission = (0, react_redux_1.useSelector)((state) => state.isCommission);
    return ((0, jsx_runtime_1.jsxs)(components_1.SubHeaderGrid, Object.assign({ noStickyOnPC: true }, { children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ onClick: () => {
                    if (window.isWebViewStack)
                        (0, webview_app_1.postMessageToWVA)('POPSTACK');
                    else
                        (0, functions_1.goBackOrMain)();
                } }, { children: (0, jsx_runtime_1.jsx)(svgs_1.HeaderBackSvg, {}) })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    display: 'flex',
                    alignItems: 'center',
                    color: 'rgba(0, 0, 0, 1)',
                    fontSize: 15,
                    fontWeight: 700,
                    cursor: 'pointer',
                }, onClick: functions_1.goToMain }, { children: [t('조금 더'), (0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/images/promise_cheer_up.png`, width: "50px", height: "50px" }), t('안전한 폰디')] })), (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ sx: { position: 'absolute', right: '48px' }, onClick: functions_1.copyUrl }, { children: (0, jsx_runtime_1.jsx)(svgs_1.ClipIconSvg, {}) })), (0, jsx_runtime_1.jsx)(IconButton_1.default, Object.assign({ sx: { position: 'absolute', right: '16px' }, "aria-controls": open ? 'more_menu' : undefined, "aria-haspopup": "true", "aria-expanded": open ? 'true' : undefined, onClick: openMenu }, { children: (0, jsx_runtime_1.jsx)(svgs_1.MoreVertSvg, { css: { width: '24px', height: '24px' } }) })), (0, jsx_runtime_1.jsxs)(Menu_1.default, Object.assign({ id: "more_menu", anchorEl: anchorEl, autoFocus: false, open: open, onClose: closeMenu, onClick: closeMenu, PaperProps: { sx: { borderRadius: '12px', mt: '4px' } }, MenuListProps: {
                    sx: {
                        '> li:first-of-type': { borderRadius: '12px 12px 0 0' },
                        '> li:last-of-type': { borderRadius: '0 0 12px 12px' },
                        '.MuiMenuItem-root': {
                            width: '200px',
                            minHeight: '52px',
                            p: '0 12px 0 16px',
                            whiteSpace: 'normal',
                            wordBreak: 'break-word',
                            fontSize: '17px',
                        },
                    },
                }, transformOrigin: { horizontal: 'right', vertical: 'top' }, anchorOrigin: { horizontal: 'right', vertical: 'bottom' } }, { children: [!isDemandSurvey && !isCommission && ((0, jsx_runtime_1.jsx)(MenuItem_1.default, Object.assign({ onClick: handleQnaClick }, { children: t('오류 제보') }))), !isDemandSurvey && !isCommission && ((0, jsx_runtime_1.jsx)(MenuItem_1.default, Object.assign({ onClick: handleReportClick }, { children: t('신고하기') }))), (0, jsx_runtime_1.jsx)(MenuItem_1.default, Object.assign({ onClick: handleBlockLeaderClick }, { children: t('channelName님 차단하기', { channelName: leaderNick }) }))] }))] })));
}
exports.default = default_1;
